import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "../../../helper/Helper";

const UserRow = React.memo(({ item, index, page, limit, onDelete }) => {
  return (
    <tr>
      <td>{(page - 1) * limit + index + 1}.</td>
      <td className="text-gray-9">
        <div className="d-flex align-items-center file-name-icon">
          {item.image && (
            <a href={item.image} target="_blank" rel="noopener noreferrer">
              <span className="avatar avatar-md border rounded-circle">
                <img src={item.image} alt="img" className="rounded-circle" />
              </span>
            </a>
          )}
          <div className="lh-0 ms-2">
            <h6 className="fw-medium">
              <a href="#">{item.name}</a>
            </h6>
            <span className="fs--1">{item.username}</span>
          </div>
        </div>
      </td>
      <td>
        <div>
          <h6 className="fw-bold">
            <a href="javascript:void(0);">{item.addedBy?.name}</a>
          </h6>
          <span className="fs--1">{item.addedBy?.roles}</span>
        </div>
      </td>
      <td>
        <div>
          {item.email ? (
            <a
              href={`mailto:${item.email}`}
              style={{
                color: "#007bff",
                textDecoration: "none",
              }}
            >
              {item.email}
            </a>
          ) : (
            <span style={{ color: "#999" }}>N/A</span>
          )}
        </div>
        <div>
          {item.mobile ? (
            <a
              href={`tel:${item.mobile}`}
              style={{
                color: "#007bff",
                textDecoration: "none",
              }}
            >
              +91-{item.mobile}
            </a>
          ) : (
            <span style={{ color: "#999" }}>N/A</span>
          )}
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center file-name-icon">
          {item.storeDetails?.logo && (
            <a href={item.storeDetails?.logo} target="_blank" rel="noopener noreferrer">
              <span className="avatar avatar-md border rounded-circle">
                <img
                  src={item.storeDetails?.logo}
                  alt="img"
                  className="rounded-circle"
                />
              </span>
            </a>
          )}
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to={`/stores/edit/${item.storeDetails._id}/general`}>
                {item.storeDetails?.name}
              </Link>
            </h6>
          </div>
        </div>
      </td>
      <td>{formatDate(item.createdAt)}</td>

      <td className="action-table-data">
        <div className="edit-delete-action">
          <Link
            to={`/stores/admin/permissions/${item._id}`}
            className="me-2 p-2"
            state={{ name: item.name }}
          >
            <i className="ti ti-lock me-1"></i>
            Permissions
          </Link>
 
          <Link
            to={`/stores/admin/change-password/${item._id}`}
            className="me-2 p-2"
            state={{ name: item.name }}
          >
            <i className="ti ti-key"></i>
          </Link>

          <Link
            to={item?._id ? `/stores/admin/edit/${item._id}` : "#"}
            className="me-2 p-2"
          >
            <i className="ti ti-pencil" />
          </Link>

          <a
            className="p-2"
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            onClick={(e) => {
              onDelete(item._id, "admin");
            }}
          >
            <i className="ti ti-trash" />
          </a>
        </div>
      </td>
    </tr>
  );
});

export default UserRow;
